import http from './http';

export default {
  /**
   * Get Plans That are available for the Users to Select From
   */
  getPlans() {
    return http().get(`/v1/billing/plans`);
  },
  // getCoupon(couponCode) {
  //   return http().get(`/v1/billing/coupon-code/` + couponCode)
  // },
  getTaxableStates() {
    return http().get(`/v1/billing/taxable-states`);
  },
  getBillingInfo() {
    return http().get(`/v1/billing/info`);
  },
  getPastBillingInfo() {
    return http().get(`/v1/billing/past_info`);
  },
  /**
   * Change Billing Plan
   * @param plan  //ChangeBillingPlanRequestRequest.php
   */
  // changePlan(plan) {
  //   return http().put(`/v1/billing/plans/change`, plan);
  // },
  // updateCreditCard(data) {
  //   return http().put(`/v1/billing/update-card`, data);
  // },
  // resumeSubscription() {
  //   return http().put(`/v1/billing/resume`);
  // },
  // pauseSubscription(days) {
  //   return http().put(`/v1/billing/pause`, {
  //     'duration_in_days': days
  //   });
  // },
  // unPauseSubscription(data, validationErrors = {}) {
  //   return http(validationErrors).put(`/v1/billing/un_pause`, data);
  // },
  // createCancelationAttempt(data, validationErrors = {}) {
  //   return http(validationErrors).post(`v1/cancel_attempts`, data);
  // },
}
